export const PHONE_NUMBER_REGEX = /^\d{3}?[\s.-]?\d{3}[\s.-]?\d{4}$/;
export const DATE_FORMAT = 'yyyy-MM-dd'; // i.e 1991/09/13
export const MAX_AGE = 120;
export const NAME_MIN_LENGTH = 2;
export const MIN_AGE = 18;
export const NAME_FORMAT = /^[a-zA-Z\s-]*$/;
